import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../../v2/components/ui/loadArtemisFonts';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

export default createUseStyles({
  informationContainer: {
    margin: 0,
    paddingBottom: 21,
  },
  information: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    [MediaQueries.phone]: {
      flexDirection: 'column',
    },
  },
  header: {
    fontFamily: props => props.theme.completePage.infoHeaderFontFamily,
    fontSize: 28,
    fontWeight: props => props.theme.completePage.infoHeaderFontWeight,
    paddingBottom: 7,
    borderBottom: '1px solid #333',
    marginBottom: 21,
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.completePage.infoHeaderFont])
      && loadArtemisFonts(props.theme.typography[props.theme.completePage.infoHeaderFont], props.theme.completePage.isBoldInfoHeader),
    }),
  },
  subheader: {
    fontFamily: props => props.theme.completePage.infoSubHeaderFontFamily,
    fontSize: props => props.theme.completePage.infoSubHeaderFontSize || 21,
    lineHeight: '1em',
    marginBottom: 21,
    paddingTop: 21,
    fontWeight: props => props.theme.completePage.infoSubHeaderFontWeight,
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.completePage.infoTitleFont])
      && loadArtemisFonts(props.theme.typography[props.theme.completePage.infoTitleFont], props.theme.completePage.isBoldInfoTitle),
    }),
  },
  block: {
    paddingRight: 12,
    width: '50%',
    [MediaQueries.phone]: {
      width: '100%',
      padding: 0,
    },
    '&:last-child': {
      paddingRight: 0,
      paddingLeft: 12,
      [MediaQueries.phone]: {
        padding: 0,
      },
    },
  },
});
